import Table from 'components/table/Table'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { SiteText } from 'features/shared/SiteUrlLink'
import {
  addId,
  checkAll,
  clearId,
  removeId,
} from 'features/bulk/download/downloadModalSlice'
import { DOMAIN_TYPE } from 'features/bulk/BulkCodes'
import { fail } from 'features/toast/Toast'
import TableCheckBox from 'components/table/TableCheckBox'
import FixedTable from 'components/table/FixedTable'

export const CHECKED_LIMIT = 20

const DownloadTable = () => {
  const dispatch = useDispatch()
  const { domainType, isLoading, ids, campaigns, bizChannels } = useSelector(
    state => state.bulk.downloadModal
  )
  const items =
    domainType === DOMAIN_TYPE.CAMPAIGN.name ? campaigns : bizChannels
  const title =
    domainType === DOMAIN_TYPE.CAMPAIGN.name
      ? DOMAIN_TYPE.CAMPAIGN.text
      : DOMAIN_TYPE.BIZ_CHANNEL.text
  const allChecked =
    items.length > 0 &&
    ids.length === (items.length < CHECKED_LIMIT ? items.length : CHECKED_LIMIT)
  const handleCheckedChange = (checked, id) => {
    if (checked) {
      if (ids.length === CHECKED_LIMIT) {
        fail('선택 가능한 개수가 초과되었습니다.')
      } else {
        dispatch(addId(id))
      }
    } else {
      dispatch(removeId(id))
    }
  }

  const handleAllCheckedChange = checked => {
    if (checked) {
      dispatch(checkAll())
    } else {
      dispatch(clearId())
    }
  }

  return (
    <>
      <strong className="tit_manage">
        선택 {title} <em className="fc_emph">{ids.length}</em>/{CHECKED_LIMIT}
      </strong>
      <FixedTable
        caption={`다운로드 등록 ${title}`}
        loading={isLoading}
        emptyMessage={`선택 가능한 ${title}이 없습니다.`}>
        <Table.Head>
          <Table.Column
            title={
              <TableCheckBox
                checked={allChecked}
                onCheckedChange={handleAllCheckedChange}
                disabled={items.length === 0}
              />
            }
            thClassName="th_choice"
            className="inner_cell"
            width={64}
          />
          <Table.Column
            title={`${title} (${items.length})`}
            className="inner_cell"
          />
        </Table.Head>
        <Table.Body>
          {items.map(({ id, name, siteUrl }) => {
            const checkBoxId = `chk_${id}`
            const contains = ids.includes(id)
            return (
              <Table.Row
                key={id}
                rowId={id}
                className={classNames({ on: contains })}>
                <td className="td_choice">
                  <div className="inner_cell">
                    <TableCheckBox
                      id={checkBoxId}
                      checked={contains}
                      onCheckedChange={checked => {
                        handleCheckedChange(checked, id)
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="inner_cell">
                    <label htmlFor={checkBoxId}>
                      {name}
                      {domainType === DOMAIN_TYPE.CREATIVE.name && (
                        <>
                          <br />
                          {siteUrl.individualSettingYn === 'N' ? (
                            <SiteText siteUrl={siteUrl.pcUrl} />
                          ) : (
                            <>
                              {siteUrl.pcSiteYn === 'Y' && (
                                <SiteText siteUrl={siteUrl.pcUrl} />
                              )}
                              {siteUrl.pcSiteYn === 'Y' &&
                                siteUrl.mobileSiteYn === 'Y' && <br />}
                              {siteUrl.mobileSiteYn === 'Y' && (
                                <SiteText siteUrl={siteUrl.mobileUrl} />
                              )}
                            </>
                          )}
                        </>
                      )}
                    </label>
                  </div>
                </td>
              </Table.Row>
            )
          })}
        </Table.Body>
      </FixedTable>
    </>
  )
}

export default DownloadTable
